import * as yup from 'yup';

// export const errorMessages = {
//     INVALID_EMAIL_FORMAT:
//         'Invalid e-mail address format. Please enter in format name@codahead.com',
//     REQUIRED_EMAIL: 'Email is required',
//     REQUIRED_NAME: 'Name is required',
//     REQUIRED_PASSWORD: 'Password is required',
//     REQUIRED_CLINIC: 'Clinic is required',
//     REQUIRED_FORMTYPE: 'Form type is required',
//     NAME_MAX_LENGTH: 'Imię i nazwisko nie może być dłuższe niż 50 znaków',
//     PASSWORD_MIN_LENGTH: 'Password must be at least 8 characters long',
//     PASSWORD_UPPERCASE: 'Password must contain at least one uppercase letter',
//     PASSWORD_LOWERCASE: 'Password must contain at least one lowercase letter',
//     PASSWORD_NUMBER: 'Password must contain at least one number',
//     PASSWORD_SPECIAL: 'Password must contain at least one special character',
//     REQUIRED_CODE: 'Reset code is required',
//     CODE_NUMERIC: 'Reset code must be numeric',
//     CODE_LENGTH: 'Reset code must be exactly 6 digits',
// };

export const errorMessages = {
    INVALID_EMAIL_FORMAT:
        'Nieprawidłowy format adresu e-mail. Wprowadź adres w formacie name@example.com',
    REQUIRED_EMAIL: 'Adres e-mail jest wymagany',
    REQUIRED_NAME: 'Imię i nazwisko jest wymagane',
    REQUIRED_PASSWORD: 'Hasło jest wymagane',
    REQUIRED_CLINIC: 'Klinika jest wymagana',
    REQUIRED_FORMTYPE: 'Typ formularza jest wymagany',
    NAME_MAX_LENGTH: 'Imię i nazwisko nie może być dłuższe niż 50 znaków',
    PASSWORD_REQUIREMENTS:
        'Hasło musi mieć co najmniej 8 znaków, zawierać co najmniej jedną wielką literę, jedną małą literę, jedną cyfrę oraz jeden znak specjalny (@$!%*?&).',
    REQUIRED_CODE: 'Kod resetujący jest wymagany',
    CODE_NUMERIC: 'Kod resetujący musi być liczbą',
    CODE_LENGTH: 'Kod resetujący musi składać się dokładnie z 6 cyfr',
};

const emailValidation = yup
    .string()
    //.email(errorMessages.INVALID_EMAIL_FORMAT)
    .required(errorMessages.REQUIRED_EMAIL);

const passwordValidation = yup
    .string()
    .required(errorMessages.REQUIRED_PASSWORD)
    .min(8, errorMessages.PASSWORD_REQUIREMENTS)
    .matches(/[A-Z]/, errorMessages.PASSWORD_REQUIREMENTS)
    .matches(/[a-z]/, errorMessages.PASSWORD_REQUIREMENTS)
    .matches(/[0-9]/, errorMessages.PASSWORD_REQUIREMENTS)
    .matches(/[@$!%*?&]/, errorMessages.PASSWORD_REQUIREMENTS);

const nameValidation = yup
    .string()
    .required(errorMessages.REQUIRED_NAME)
    .max(50, errorMessages.NAME_MAX_LENGTH);

const codeValidation = yup
    .string()
    .required(errorMessages.REQUIRED_CODE)
    .length(6, errorMessages.CODE_LENGTH);

export const validationSignUp = yup.object().shape({
    email: emailValidation,
    name: nameValidation,
    password: passwordValidation,
});

export const validationResetPassword = yup.object().shape({
    email: emailValidation,
});

export const validationLogin = yup.object().shape({
    email: emailValidation,
    password: yup.string().required(errorMessages.REQUIRED_PASSWORD),
});

export const validationNewPassword = yup.object().shape({
    email: emailValidation,
    password: passwordValidation,
    code: codeValidation,
});
